import ProfileRepository from './Api/ProfileRepository'
import CurrencyRepository from './Api/CurrencyRepository'
import SeniorRepository from './Api/SeniorRepository'
import MasterRepository from './Api/MasterRepository'
import AgentRepository from './Api/AgentRepository'
import PlayerRepository from './Api/PlayerRepository'
import AccountRepository from './Api/AccountRepository'
import TransactionRepository from './Api/TransactionRepository'
import BalanceReportRepository from './Api/BalanceReportRepository'
import DashboardRepository from './Api/DashboardRepository'
import DepositSettingRepository from './Api/DepositSettingRepository'
import BetHistoryRepository from './Api/BetHistoryRepository'
import ParleyReportRepository from './Api/ParleyReportRepository'
import DomainRepository from './Api/DomainRepository'
import BaccaratBalanceReportRepository from './Api/BaccaratBalanceReportRepository'
import ChannelRepository from './Api/ChannelRepository'
import ChannelBaccarateRepository from './Api/ChannelBaccarateRepository'
import ChannelCockRepository from './Api/ChannelCockRepository'
import BaccaratResultRepository from './Api/BaccaratResultRepository'
import MemberRepository from './Api/MemberRepository'
import BetTransactionRepository from './Api/BetTransactionRepository'
import slotBalanceReportRepository from './Api/slotBalanceReportRepository'
import AssistantRepository from './Api/AssistantRepository'
import PromotionHistoryRepository from './Api/PromotionHistoryRepository'
import BalanceReportByTypeRepository from './Api/BalanceReportByTypeRepository'
import JackpotHistoryRepository from './Api/JackpotHistoryRepository'
import DepositRequestRepository from './Api/DepositRequestRepository'
import WithdrawRequestRepository from './Api/WithdrawRequestRepository'
import AssistantVvipRepository from './Api/AssistantVvipRepository'

const repositories = {
  account: AccountRepository,
  agent: AgentRepository,
  assistant: AssistantRepository,
  baccaratBalanceReport: BaccaratBalanceReportRepository,
  baccaratResult: BaccaratResultRepository,
  balanceReport: BalanceReportRepository,
  balanceReportByType: BalanceReportByTypeRepository,
  betHistory: BetHistoryRepository,
  betTransaction: BetTransactionRepository,
  channel: ChannelRepository,
  channelBaccarate: ChannelBaccarateRepository,
  channelCock: ChannelCockRepository,
  currency: CurrencyRepository,
  dashboard: DashboardRepository,
  depositRequest: DepositRequestRepository,
  depositSetting: DepositSettingRepository,
  domain: DomainRepository,
  jackpotHistory: JackpotHistoryRepository,
  master: MasterRepository,
  member: MemberRepository,
  parleyReport: ParleyReportRepository,
  player: PlayerRepository,
  profile: ProfileRepository,
  promotionHistory: PromotionHistoryRepository,
  senior: SeniorRepository,
  slotBalanceReport: slotBalanceReportRepository,
  transaction: TransactionRepository,
  withdrawRequest: WithdrawRequestRepository,
  assistantVvip: AssistantVvipRepository,
}

export default {
  get: name => repositories[name],
}
